export default "__VITE_ASSET__eFMTPnK2__"